/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/categories/categoriesActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { CreateCategoryForm } from "./CreateCategoryForm";
import { EditCategoryForm } from "./EditCategoryForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";

const initCategory = {
  id: undefined,
  name: "",
  icon: "",
};

export function CategoryEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  // Subheader
  const suhbeader = useSubheader();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, categoryForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.categories.actionsLoading,
      categoryForEdit: state.categories.categoryForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchCategory(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New Category";
    if (categoryForEdit && id) 
	{
      _title = `Edit Category '${categoryForEdit.name}'`;
    
	}

    setTitle(_title);
    suhbeader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryForEdit, id]);

  const saveCategory = (values) => {
    if (!id) {
      dispatch(actions.createCategory(values)).then(() => backToCategoriesList());
    } else {
      dispatch(actions.updateCategory(values)).then(() => backToCategoriesList());
    }
  };

  const btnRef = useRef();  
  const saveCategoryClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToCategoriesList = () => {
    navigate("/category");
  };

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type="button"
            onClick={backToCategoriesList}
            className="btn btn-light"
          >
            <i className="fa fa-arrow-left"></i>
            Back
          </button>
          {`  `}
          <button
            type="submit"
            className="btn btn-primary ml-2"
            onClick={saveCategoryClick}
          >
            Save
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <ul className="nav nav-tabs nav-tabs-line " role="tablist">
          <li className="nav-item" onClick={() => setTab("basic")}>
            <a
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle="tab"
              role="tab"
              aria-selected={(tab === "basic").toString()}
            >
              Basic info
            </a>
          </li>
          
		  
		  
        </ul>
        <div className="mt-5">
          {tab === "basic" && id && (
            <EditCategoryForm
              actionsLoading={actionsLoading}
              category={categoryForEdit || initCategory}
              btnRef={btnRef}
              saveCategory={saveCategory}
            />
          )}
		  
		  {tab === "basic" && !id && (
            <CreateCategoryForm
              actionsLoading={actionsLoading}
              category={categoryForEdit || initCategory}
              btnRef={btnRef}
              saveCategory={saveCategory}
            />
          )}
		 
		  
        </div>
      </CardBody>
    </Card>
  );
}